// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"notificationPreferences_rentalProperties_areaGroup":{"f":""},"notificationPreferences_rentalNeeds_areaGroup":{"f":""},"notificationPreferences_forSaleProperties_areaGroup":{"f":""},"notificationPreferences_buyerNeeds_areaGroup":{"f":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = ((function(){
var v0 = [
  {
    "kind": "RequiredField",
    "field": {
      "alias": null,
      "args": null,
      "concreteType": "ChapterAreaGroup",
      "kind": "LinkedField",
      "name": "areaGroup",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NotificationSettingsPreferenceEditDialog_areaGroup"
        }
      ],
      "storageKey": null
    },
    "action": "NONE"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsPreferenceEditDialog_chapter",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NotificationSettingsPreferenceEditDialogAreaGroups_chapter"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChapterNotificationPreferencesV5",
      "kind": "LinkedField",
      "name": "notificationPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ChapterPropertyNotificationPreference",
            "kind": "LinkedField",
            "name": "forSaleProperties",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ChapterPropertyNotificationPreference",
            "kind": "LinkedField",
            "name": "rentalProperties",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ChapterClientNeedNotificationPreference",
            "kind": "LinkedField",
            "name": "buyerNeeds",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "ChapterClientNeedNotificationPreference",
            "kind": "LinkedField",
            "name": "rentalNeeds",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChapterV5",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
